import { MouseEventHandler, ReactNode } from 'react'
import { debounce } from 'lodash'

import * as S from './styled'

export type ButtonProps = {
  children: ReactNode
  className?: string
  minWidth?: number
  size?: 'large' | 'medium' | 'small' | 'xsmall' | 'sizeFiler'
  variant?:
    | 'primary'
    | 'default'
    | 'secondary'
    | 'loggedOut'
    | 'warn'
    | 'alternative'
    | 'permission'
    | 'module'
    | 'certification'
    | 'map'
    | 'filter'
    | 'fixed'
  onClick: MouseEventHandler
  border?: 'yes' | 'not'
  disabled?: boolean
}

export function Button({
  children,
  className = '',
  minWidth = 6,
  size = 'medium',
  variant = 'primary',
  onClick,
  border = 'not',
  disabled = false
}: ButtonProps) {
  return (
    <S.Button
      className={`${variant} ${size} ${className} ${border} ${
        disabled ? 'disabled' : ''
      }`}
      minWidth={minWidth}
      onClick={debounce(onClick, 600)}
      disabled={disabled}
    >
      {children}
    </S.Button>
  )
}
